window.submissionsBuffer = (() => {
    const storeName = 'Submissions'
    let db;
    
    function getDb() {
        if (db) return db;
        return new Promise((res, rej) => {
            const request = indexedDB.open(storeName);
            request.onsuccess = e => res(db = e.target.result);
            request.onerror = e => rej(e.target.error);
            request.onupgradeneeded = e => e.target.result.createObjectStore(storeName, { keyPath: "id" });
        });
    }

    async function writeBuffer(filename, buffer) {
        const db = await getDb();
        const store = db.transaction(storeName, 'readwrite').objectStore(storeName);
        store.add({ id: filename, content: new Uint8Array(buffer) });
    }

    async function writeStream(filename, dotnetStreamRef) {
        const buffer = await dotnetStreamRef.arrayBuffer();
        await writeBuffer(filename, new Uint8Array(buffer));
    }

    async function getAll() {
        const db = await getDb();
        const store = db.transaction(storeName).objectStore(storeName);
        return new Promise(res => store.getAll().onsuccess = e => res(e.target.result));
    }

    async function remove(filename) {
        const db = await getDb();
        const store = db.transaction(storeName, 'readwrite').objectStore(storeName);
        store.delete(filename);
    }

    return {
        add: writeStream,
        remove,
        getAll,
    };
})();